import { get } from "./api";
import type {
  BulkOutreachRecordPage,
  BulkOutreachDetailResponse,
} from "../types/crm";

export const getBulkOutreachRecords = (
  pageNumber = 1,
  pageSize = 20
): Promise<BulkOutreachRecordPage> =>
  get(`/api/crm/bulk-outreach?pageNumber=${pageNumber}&pageSize=${pageSize}`);

export const getBulkOutreachDetail = (id: string): Promise<BulkOutreachDetailResponse> =>
  get(`/api/crm/bulk-outreach/${id}`);
